import router from './router'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { isHttp } from '@/utils/validate'
import { isRelogin } from '@/utils/request'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
import usePermissionStore from '@/store/modules/permission'
import { initTccc } from "@/utils/Tccc";
import { handleH5Cache } from "@/utils/h5Cache.js";
import { showToast } from "vant";
NProgress.configure({ showSpinner: false });

const whiteList = [
  '/interviewAppDownload',
  '/h5/form','/h5/newYearConcert',
  '/login',
  '/agent/login',
  '/register',
  '/cas/login',
  '/cas/index',
  '/auth/mainPlatform/loginFromWX',
  '/auth/loginFromWX',
  '/onlinePreviewFile',
  '/onlinePreviewFileHtml',
  '/ext/login',
  '/employment/login',
  '/employeeDevelopmentCenter',
  '/h5/jumpCenter',
  '/h5/aiQiHang',
  '/h5/print3D',
  '/h5/jumpMini'
];

/**获取传递的参数 */
function getUrlParam (url) {
  var object = {};
  if (url.indexOf("?") !== -1) {
    var str = url.split("?")[1];
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      object[strs[i].split("=")[0]] = strs[i].split("=")[1]
    }
    return object
  }
  return object[url];
}

/**拉取user_info信息 */
function handleUserInfo (to, next, from) {
  if (useUserStore().roles.length === 0) {
    isRelogin.show = true
    // 判断当前用户是否已拉取完user_info信息
    useUserStore().getInfo().then(() => {
      if (!to.path.match(/(^\/h5)|(^\/qwTools)/)) {
        initTccc(true, false)
      }
      isRelogin.show = false
      usePermissionStore().generateRoutes().then(accessRoutes => {
        // 根据roles权限生成可访问的路由表
        accessRoutes.forEach(route => {
          if (!isHttp(route.path)) {
            router.addRoute(route) // 动态添加可访问路由表
          }
        })
        if (to.path.includes('/auth/loginFromCenter')) {
          console.log(to, '789-1');
          const { callBackUrl } = to.query;
          if (callBackUrl) {
            console.log(to, '789-2');
            if (callBackUrl.indexOf('http') == 0) {
              location.replace(callBackUrl);
            } else {
              next({ path: callBackUrl, query: getUrlParam(callBackUrl) });
            }
          } else {
            console.log(to, '789-3');
            next({ path: '/' })
          }
        } else {
          console.log(to, '789-4');
          try {
            const callBackUrl = to.redirectedFrom?.query?.callBackUrl;
            if (callBackUrl) {
              console.log(to, '789-5');
              if (callBackUrl.indexOf('http') == 0) {
                console.log(to, '789-6');
                location.replace(callBackUrl);
              } else {
                console.log(to, '789-7');
                next({ path: callBackUrl, query: getUrlParam(callBackUrl) });
              }
            } else {
              console.log(to, '789-8');
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
            }
          } catch (e) {
            console.log(to, '789-9', e);
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          }
        }
      })
    }).catch(err => {
      if (to.path.match(/^\/h5/)) {
        showToast('登录已失效，请返回小程序重新登录')
      } else {
        useUserStore().logOut().then(() => {
          // next({ path: '/' })
          location.reload();
        })
      }

    })
  } else {
    handleH5Cache(to, from)
    next()
  }
}



if (location.host.indexOf('whrhkj') > -1) {
  document.title = '仁和会计企业管理平台';
  // Main平台域名：
  router.beforeEach((to, from, next) => {
      // 解决三级菜单组件无法缓存问题
      if (to.matched && to.matched.length > 2) {
        to.matched.splice(1, to.matched.length - 2);
      }

    if (!['/cas/login', '/auth/mainPlatform/loginFromWX', '/cas/index'].includes(to.path)) {
      next({ path: '/cas/login' }) // 非main平台的3个页面全部重定向到main登录页
    } else {
      next()
    }
  })
} else {
  // 若衣域名：
  router.beforeEach((to, from, next) => {
    // 解决三级菜单组件无法缓存问题
    if (to.matched && to.matched.length > 2) {
      to.matched.splice(1, to.matched.length - 2);
    }

    if (['/auth/loginFromWX'].includes(to.path)) {
      next();
      NProgress.done();
      return;
    };

    NProgress.start()
    if (!to.path.match(/^\/h5/)) {
      document.title = '仁和CRM';
    } else {
      document.title = to.meta?.title || '' // 适配h5标题
    }

    if (getToken()) {
      /*if (whiteList.indexOf(to.path) !== -1) {
        next()
        NProgress.done()
      } else*/ if (to.path.includes('/auth/loginFromCenter')) {  //判断是否是模拟登录
        console.log(to, '123-1')
        useUserStore().logOut().then(() => {
          const { workNo, uinxTime, sign, loginFromSource } = to.query
          useUserStore().loginFromCenter({ workNo, uinxTime, sign, loginFromSource }).then(res => {
            console.log(to, '123-2')
            handleUserInfo(to, next, from)
          }).catch((err) => {
            console.log(err, to, '123-3')
            next({ path: '/' })
          })
        })
      } else if (to.path.includes('/h5/jumpCenter') || to.path.includes('/h5/form') || to.path.includes('/h5/newYearConcert')
        || to.path.includes('/h5/aiQiHang') || to.path.includes('/h5/print3D')
      ) { // 小程序传token跳入中转页，直接放行
        next()
        NProgress.done()
      } else {
        to.meta.title && useSettingsStore().setTitle(to.meta.title)
        /* has token*/
        if (to.path === '/login') {
          next({ path: '/' })
          NProgress.done()
        } else if (to.path == '/ext/login') {
          useUserStore().logOut().then(() => {
            location.reload();
          })
        } else {
          handleUserInfo(to, next, from)
        }
      }
    } else {
      // 没有token
      if (whiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        if (to.path === "/login") {
          if (to.query?.redirect?.includes('/auth/loginFromCenter')) {
            console.log(to, '456-1')
            const { workNo, uinxTime, sign, loginFromSource } = getUrlParam(to.query.redirect)
            useUserStore().loginFromCenter({ workNo, uinxTime, sign, loginFromSource }).then(res => {
              console.log(to, '456-2')
              handleUserInfo(to, next, from)
            }).catch((err) => {
              console.log(to, '456-3')
              next()
              NProgress.done()
            })
          } else {
            const loginType = sessionStorage.getItem('_login_type_') || '0';
            if (loginType == 1) {
              // 1 外部用户
              next({ path: '/ext/login', query: { redirect: to.query?.redirect } });
            } else if (loginType == 2 || to.query?.redirect?.startsWith('/qwTools')) {
              // 2 内部用户且为企微内嵌
              next();
            } else if(loginType == 3){
              next({ path: '/employment/login', query: { redirect: to.query?.redirect } })
            } else {
              const activeTabKey = '__activeTabKey__';
              if (getUrlParam(to.fullPath)?.activeTab == 1) {
                sessionStorage.setItem(activeTabKey, 1);
              } else {
                sessionStorage.removeItem(activeTabKey);
              }
              const hostKey = location.hostname.split('.')[0];
              if (hostKey == 'localhost' || /^\d+$/.test(hostKey.split('.').join('')) || sessionStorage.getItem(activeTabKey) == 1) {
                // 本地走login
                next();
              } else {
                // 默认 走main平台
                const hostMap = {
                  centertest: 'maintest',
                  centerpre: 'mainpre',
                  center: 'main'
                };
                const mappedHost = hostMap[hostKey] || 'main';
                const loginUrl = `https://${mappedHost}.whrhkj.com/cas/login`;

                location.replace(loginUrl);
              }
            }

            NProgress.done()
          }
        } else {
          next()
          NProgress.done()
        }
      } else {
        next({ path: '/login', query: { redirect: to.fullPath } }) // 否则全部重定向到登录页
      }
    }
  })
}


router.afterEach((to, from, next) => {
  try {
    $("html")
      .removeClass(
        ($("html")
          .attr("class")
          .match(/page-name-[^\s]+/) || [""])[0]
      )
      .addClass(`page-name-${to.name}`);
  } catch (e) { }

  NProgress.done()
})
